import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { listRoles } from './rolesApi';
import './roles.css';

export default function RolesPage() {
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = useCallback(async () => {
    setLoading(true); setError(false);
    try {
      const r = await listRoles();
      setRoles(r);
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading) return <div className="rbac-skeleton" aria-busy="true">Loading roles…</div>;
  if (error) return <div className="rbac-error">Could not load roles. <button className="btn" onClick={load}>Retry</button></div>;

  return (
    <div className="rbac-page">
      <div className="rbac-toolbar">
        <button className="btn btn-primary" onClick={() => navigate('/admin/roles/new')}>New role</button>
      </div>

      {roles.length === 0 ? (
        <div className="rbac-empty">
          <p>No roles yet.</p>
          <button className="btn btn-primary" onClick={() => navigate('/admin/roles/new')}>New role</button>
        </div>
      ) : (
        <div className="rbac-tablewrap">
        <table className="rbac-table">
          <thead>
            <tr><th>Role</th><th>Permissions</th><th>Users</th><th></th></tr>
          </thead>
          <tbody>
            {roles.map((r) => (
              <tr key={r.id}>
                <td>
                  <span className="rbac-role-name"><Link to={`/admin/roles/${r.id}`}>{r.label}</Link></span>
                  {r.is_system && <span className="rbac-badge">System role</span>}
                  {r.description && <div className="rbac-role-desc">{r.description}</div>}
                </td>
                {/* The admin role is a superuser bypass with no rows in
                    role_permissions: "0" would read as "can do nothing". */}
                <td className="rbac-num">{r.key === 'admin' ? 'All' : r.permission_count}</td>
                <td className="rbac-num">{r.user_count}</td>
                <td className="rbac-row-actions">
                  <Link className="btn btn-secondary" to={`/admin/roles/${r.id}`}>Open</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      )}
    </div>
  );
}
